import React, { useEffect, useMemo, useState } from "react";
import AsyncSelect from "react-select/async";
import instance from "../../Interceptor/api_instance";
import debounce from "lodash.debounce";
import { customStyles } from "../Utility/ReactSelectStyles";
import { useTranslation } from "react-i18next";

const DriverOutSearch = ({ onSelect, selectedDriver }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const filterOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 1) return [];

    try {
      const res = await instance.get(
        `assets/get-visitors?category=Driver&name=${inputValue}&q=10`
      );
      return res.data.map((visitor) => ({
        ...visitor.visitor,
        value: visitor.visitor.id,
        label: visitor.visitor.full_name,
      }));
    } catch (err) {
      console.error("Failed to fetch visitors: ", err);
      return [];
    }
  };

  useEffect(() => {
    setIsLoading(true);
    if (selectedDriver) filterOptions(selectedDriver.label);
    setIsLoading(false);
  }, []);

  // ✅ Debounce filterOptions and return a wrapped function that resolves a Promise
  const debouncedLoadOptions = useMemo(() => {
    const wrapped = debounce((inputValue, callback) => {
      filterOptions(inputValue).then(callback);
    }, 1000);
    return (inputValue) =>
      new Promise((resolve) => wrapped(inputValue, resolve));
  }, []);

  return (
    <AsyncSelect
      cacheOptions
      name="driver"
      aria-label="Driver"
      inputId="driver-select"
      value={selectedDriver}
      isLoading={isLoading}
      loadingMessage={() => t("general.loading")}
      defaultOptions={false}
      loadOptions={debouncedLoadOptions}
      onChange={onSelect}
      placeholder={t("forms.type.vehicle.search.visitor.search")}
      noOptionsMessage={() => t("forms.type.vehicle.search.visitor.not-found")}
      isClearable
      className="search-select"
      styles={customStyles}
      unstyled={true}
      required
    />
  );
};

export default DriverOutSearch;
